"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawalMember = void 0;
var qs = require("qs");
function withdrawalMember(axios) {
    return {
        // [WithdrawalMember]
        getWithdrawalMembers: function (request) {
            return axios.get('/withdrawal-members', request);
        },
        putWithdrawalMembers: function (request) {
            if (!request.headers) {
                return axios.put('/withdrawal-members', request.data);
            }
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.put('/withdrawal-members', request.data, config);
        },
        getWithdrawalMembersRejoinability: function (request) {
            return axios.get('/withdrawal-members/rejoinability', request);
        },
        putWithdrawalMembersRejoinability: function (request) {
            return axios.put('/withdrawal-members/rejoinability', request.data);
        },
        putWithdrawalMembersRestore: function (request) {
            return axios.put('/withdrawal-members/restore', request.data);
        },
        deleteWithdrawalMembers: function (request) {
            var query = qs.stringify(request.params);
            return axios.delete("/withdrawal-members?" + query);
        }
    };
}
exports.withdrawalMember = withdrawalMember;
